import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import logoBlack from '../assets/images/logo-light2.png'
import { dividerStyles } from '../core/constants/styles'
import { useSelector } from 'react-redux';
const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const headerTheme = useSelector((state: any) => state.setting.headerTheme);
  let layoutFlag = true;
  if (location.pathname === '/shoppingcart') layoutFlag = false;
  if (location.pathname === '/checkout') layoutFlag = false;
  if (location.pathname === '/orderconfirmation') layoutFlag = false;
  const footerColor = headerTheme === 'white' ? ' bg-white ' : ' bg-darkGreen ';
  const fontColor = headerTheme === 'white' ? ' text-black ' : ' text-lemonGrass ';
  const isNotFoundPage = location.pathname === '/404';

  return (
    <div className={isNotFoundPage ? 'mt-0' : 'mt-25'}>
      <div className={footerColor + fontColor}>
        <div className="max-w-mxWidth mx-auto">
          <div className={" text-16 " + (layoutFlag ? 'pt-20 ' : '')}>
            <div className={`${dividerStyles.horizontal} mb-20`} />
              <div className='flex flex-wrap items-center justify-between'>
                <div className="mx-20">
                  <img className='h-30 min-h-30 cursor-pointer' src={logoBlack} alt='' onClick={() => {
                    window.open('https://bigrentals.com', '_blank');
                  }}/>
                  <p className="my-16 whitespace-nowrap">Big equipment rentals made easy.</p>
                </div>
                <div className="flex flex-wrap mx-20">
                  <p className="mr-24 my-8 cursor-pointer whitespace-nowrap" onClick={() => navigate('/privacy-policy')}>Privacy Policy</p>
                  <p className="mr-24 my-8 cursor-pointer whitespace-nowrap" onClick={() => navigate('/terms-service')}>Terms of Service</p>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Footer;